<template>
  <div class="grid">
    <div class="grid__cell col12-of-12--medium-up fade-in">
      <div class="list__title mb-sm fade-in">
        <div class="grid__cell col7-of-12--medium mb-md">
          <BackButton
            link="/integration-partners"
            text="Back to Technology partner profiles"
          />
          <h3 class="fw-bold fs-xl mb-xs">Add Integration Partners</h3>
          <p class="fc-darker fs-md mr-lg">
            Search and add partners to your Integration Directory
          </p>
        </div>
        <div class="grid__cell col5-of-12--medium mb-md"></div>
      </div>

      <div class="grid__cell col12-of-12--medium mb-md">
        <div class="table-toolbar mb-xs" style="padding-left: 1rem;">
          <label class="searcher">
            <input
              data-hj-allow
              @input="search($event.target.value)"
              :value="query"
              placeholder="Search"
              type="text"
            />
          </label>
          <span v-if="query">
            Can't find a vendor?
            <router-link to="/integration-partners/create" class="fc-violet">
              Create Partner Manually
            </router-link>
            or
            <router-link to="/invite/vendor" class="fc-violet">
              Send an Invitation
            </router-link>
            instead.
          </span>
        </div>
        <template v-if="loading">
          <Logo />
        </template>
        <template v-else>
          <div class="list" :class="listClass">
            <div
              v-for="vendor in candidates"
              :key="vendor.id"
              class="grid__cell col2-of-12--small col6-of-12--medium col4-of-12--large col4-of-12--laptop-up mb-md"
            >
              <a class="card card--vendor tech--vendor theme-border-base">
                <div class="card__main">
                  <div class="card__content">
                    <div class="card__image ta-center theme-border-base p-md">
                      <img
                        v-if="vendor.image"
                        :alt="vendor.name"
                        :src="vendor.image"
                      />
                    </div>
                    <div class="card__truncate">
                      <p class="fw-bold theme-text-dark fs-md mb-xs truncate">
                        {{ vendor.name }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card__footer">
                  <Button
                    bWidth="expanded"
                    class="ta-center"
                    v-on:button-click="addPartner(vendor.id)"
                  >
                    Add partner
                  </Button>
                </div>
              </a>
            </div>

            <div
              class="grid__cell col2-of-12--small col6-of-12--medium col4-of-12--large col4-of-12--laptop-up mb-md"
              :class="listClass"
            >
              <router-link
                to="/integration-partners/create"
                class="card card--vendor tech--vendor theme-border-base"
              >
                <div style="padding: 1.5rem;">
                  <div
                    class="dash-card__image ta-center theme-border-base"
                    style="height: 8rem; margin-bottom: 1.5rem;"
                  >
                    <svg
                      style="padding-top: 25px;"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      version="1.1"
                      width="96px"
                      height="96px"
                    >
                      <g>
                        <path
                          style=" fill-rule:evenodd;"
                          d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z "
                        />
                      </g>
                    </svg>
                  </div>
                  <p
                    class="fw-bold theme-text-dark ta-center fs-md mt-sm mb-xs"
                    style="margin-top: 0;"
                  >
                    Create Partner Manually
                  </p>
                </div>
                <div class="card__footer">
                  <Button
                    bWidth="expanded"
                    @button-click="navTo('/integration-partners/create')"
                  >
                    Create Partner
                  </Button>
                </div>
              </router-link>
            </div>
          </div>
          <smart-pagination
            class="ml-sm"
            :currentPage.sync="currentPage"
            :count="count"
            :pageSize="pageSize"
            v-on:update:currentPage="pageChanged($event)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Button from '@/components/DesignSystem/Button';
import BackButton from '@/components/BackButton';
import Logo from '@/components/SpinningLogo';
const { mapGetters, mapActions, mapState } = createNamespacedHelpers(
  'integrationPartners/addIntegrationPartner'
);
export default {
  name: 'IntegrationPartnersAdd',
  components: {
    Button,
    BackButton,
    Logo,
  },
  data() {
    return {
      vendors: [],
      searchQuery: '',
      listClass: '',
      debounce: null,
    };
  },
  computed: {
    ...mapGetters(['candidates']),
    ...mapState(['query', 'pageSize', 'count', 'currentPage', 'loading']),
  },
  methods: {
    ...mapActions([
      'fetchCandidates',
      'addPartner',
      'searchCandidates',
      'setCurrentPage',
    ]),
    navTo(where) {
      this.$router.push(where);
    },
    pageChanged(page) {
      this.setCurrentPage(page);
      this.fetchCandidates(page);
    },
    search(value) {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(() => {
        this.searchCandidates(value);
      }, 500);
    },
  },
  created() {
    this.fetchCandidates();
  },
};
</script>
